import { notificationsActions } from './slice';

export type NotificationActionType = {
  type: string;
  payload: string;
};

export const enqueueSuccessSnackbar =
  notificationsActions.enqueueSuccessSnackbar as (
    payload: string,
  ) => NotificationActionType;

export const enqueueErrorSnackbar =
  notificationsActions.enqueueErrorSnackbar as (
    payload: string,
  ) => NotificationActionType;

export const enqueueWarningSnackbar =
  notificationsActions.enqueueWarningSnackbar as (
    payload: string,
  ) => NotificationActionType;

export const enqueueInfoSnackbar = notificationsActions.enqueueInfoSnackbar as (
  payload: string,
) => NotificationActionType;

export const removeSnackbar = notificationsActions.removeSnackbar as (
  payload: number,
) => void;
